import {UniversalLifeGraceLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';
import {toMoneyValue} from 'Shared/utilities/FormatMoney';

type GraceLetterProps = {
  graceLetter: UniversalLifeGraceLetter;
};

const GraceLetter = (props: GraceLetterProps) => {
  return (
    <>
      <CardField name="Date" value={toFormattedDateAsUTC(props.graceLetter.date)} />
      <CardField name="Owner Name" value={props.graceLetter.ownerName} />
      <CardField name="Owner Address" value={props.graceLetter.ownerAddress!.fullAddress} />
      <CardField name="Payment Due Date" value={toFormattedDateAsUTC(props.graceLetter.paymentDueDate)} />
      <CardField name="Minimum Payment Due" value={toMoneyValue(props.graceLetter.minimumPaymentDue)} />
      <CardField name="Insured Name" value={props.graceLetter.insuredName} />
      <CardField name="Agent Number" value={props.graceLetter.agentNumber} />
    </>
  );
};

export default GraceLetter;
